import { render } from "./StudentTabs.vue?vue&type=template&id=b5d56a70&scoped=true"
import script from "./StudentTabs.vue?vue&type=script&lang=js"
export * from "./StudentTabs.vue?vue&type=script&lang=js"

import "./StudentTabs.vue?vue&type=style&index=0&id=b5d56a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d56a70"]])

export default __exports__